import React from 'react';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Grid, IconButton } from '@mui/material';

import ChatBody from '../../sections/chat/ChatBody'; 
import ChatInput from './ChatInput';
import Navbar from './Navbar';
import Iconify from '../../components/iconify';

const StyledTabPanel = styled(TabPanel)(() => ({
  height: 'calc(105%)',
  backgroundImage: `url('/assets/chat/cross.png')`,
  padding: 0,
  paddingLeft: 2,
  paddingRight: 2,
  overflow: 'auto',
}));

export default function Main({
  user,
  targetType, 
  targetName,
  churchChats,
  handleDelete,
  handleEdit,
  roleChats,
  categoryChats,
  publicChats,
  personalChats,
  districtChats,
  unReadChats,
  manageTarget, 
  value,
  setValue, 
  body,
  preBody,
  setBody,
  postNewChat,
  cancelEdit,
  chatIdToBeEdited,
  openSideBar,
  setOpenSideBar,
  targetId
}) {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '80%' },
        filter: openSideBar ? 'blur(3px)' : 'none',
        pointerEvents: openSideBar ? 'none' : 'auto',
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Box sx={{ height: { xs: 'calc(100vh - 290px)', sm: 'calc(100vh - 400px)' } }}>
            <TabContext value={value}>
              <Box sx={{ display: 'flex' }}>
                <IconButton
                  onClick={() => setOpenSideBar(!openSideBar)}
                  sx={{
                    color: 'text.primary',
                    display: { sm: 'none' },
                    width: 45,
                    height: 45,
                    p: 0,
                  }}
                >
                  <Iconify icon="eva:menu-fill" />
                </IconButton>
                <Navbar
                  user={user}
                  unReadChats={unReadChats}
                  manageTarget={manageTarget}
                  setValue={setValue}
                  targetType={targetType}
                />
              </Box>

              <StyledTabPanel value="public">
                <ChatBody
                  chats={publicChats}
                  targetType={targetType}
                  targetName={targetName}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  canEdit={user && user.role.permissions.publicChat.update}
                  canDelete={user && user.role.permissions.publicChat.delete}
                />
              </StyledTabPanel>
              <StyledTabPanel value="personal">
                <ChatBody
                  chats={personalChats}
                  targetType={targetType}
                  targetName={targetName}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  canEdit={user && user.role.permissions.personalChat.update}
                  canDelete={user && user.role.permissions.personalChat.delete}
                />
              </StyledTabPanel>
              <StyledTabPanel value="district">
                <ChatBody
                  chats={districtChats}
                  targetType={targetType}
                  targetName={targetName}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  canEdit={user && user.role.permissions.ownDistrictChat.update}
                  canDelete={user && user.role.permissions.ownDistrictChat.delete}
                />
              </StyledTabPanel>
              <StyledTabPanel value="church">
                <ChatBody
                  chats={churchChats}
                  targetType={targetType}
                  targetName={targetName}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  canEdit={user && user.role.permissions.ownChurchChat.update}
                  canDelete={user && user.role.permissions.ownChurchChat.delete}
                />
              </StyledTabPanel>
              <StyledTabPanel value="category">
                <ChatBody
                  chats={categoryChats}
                  targetType={targetType}
                  targetName={targetName}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  canEdit={user && user.role.permissions.ownCategoryChat.update}
                  canDelete={user && user.role.permissions.ownCategoryChat.delete}
                />
              </StyledTabPanel>
              <StyledTabPanel value="role">
                <ChatBody
                  chats={roleChats}
                  targetType={targetType}
                  targetName={targetName}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  canEdit={user && user.role.permissions.ownRoleChat.update}
                  canDelete={user && user.role.permissions.ownRoleChat.delete}
                />
              </StyledTabPanel>
            </TabContext>
          </Box>
        </Grid>
        <ChatInput
          user={user}
          body={body}
          preBody={preBody}
          setBody={setBody}
          postNewChat={postNewChat}
          cancelEdit={cancelEdit}
          chatIdToBeEdited={chatIdToBeEdited}
          targetName={targetName}
          targetType={targetType}
          targetId={targetId}
        />
      </Grid>
    </Box>
  );
}

// PropTypes validation
Main.propTypes = {
  user: PropTypes.object.isRequired,
  targetType: PropTypes.string.isRequired, 
  targetName: PropTypes.string.isRequired,
  churchChats: PropTypes.array.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  roleChats: PropTypes.array.isRequired,
  categoryChats: PropTypes.array.isRequired,
  publicChats: PropTypes.array.isRequired,
  personalChats: PropTypes.array.isRequired,
  districtChats: PropTypes.array.isRequired,
  unReadChats: PropTypes.array.isRequired,
  manageTarget: PropTypes.func.isRequired, 
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired, 
  body: PropTypes.string.isRequired,
  preBody: PropTypes.string.isRequired,
  setBody: PropTypes.func.isRequired,
  postNewChat: PropTypes.func.isRequired,
  cancelEdit: PropTypes.func.isRequired,
  chatIdToBeEdited: PropTypes.string.isRequired,
  openSideBar: PropTypes.bool.isRequired,
  setOpenSideBar: PropTypes.func.isRequired,
  targetId: PropTypes.string.isRequired,
};
